import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EquipmentService {

  // 固定参数
  private uri = 'plan/api/business/equipment';

  constructor(private httpClient: HttpClient) { }

  async getStisfactionRtio() {
    return await this.httpClient.get('plan/api/operation/getStisfactionRtio').toPromise();
  }

  async getRepaireRatio(flag?: boolean) {
    let url = `plan/api/operation/getRepaireRatio`;
    if (flag !== undefined && flag !== null && flag === true) {
      url = url + `?flag=${flag}`;
    }
    return await this.httpClient.get(url).toPromise();
  }

  async getYearOperationPlanDistinctType(repair?: string) {
    let url = 'plan/api/operation/getYearOperationPlanDistinctType';
    if (repair === 'repair') {
      url = url + `?repair=${repair}`;
    }
    return await this.httpClient.get(url).toPromise();
  }

  async getEquipmentCountByType() {
    return await this.httpClient.get('plan/api/operation/getEquipmentCountByType').toPromise();
  }

  async getRepairPeriodByMonthes() {
    return await this.httpClient.get('plan/api/operation/getRepairPeriodByMonthes').toPromise();
  }

  getUnmarkedEquipmentCount() {
    return this.httpClient.get(this.uri + '/unmarkedEquipmentCount');
  }

  getEquipmentTypeList() {
    return this.httpClient.get(this.uri + '/queryEquipmentType');
  }

  getEquipmentMarkStatusList() {
    return this.httpClient.get(this.uri + '/queryMarkStatus');
  }

  getEquipmentExpireStatusList() {
    return this.httpClient.get(this.uri + '/queryExpireStatus');
  }

  async queryFacilityDataById(eno: string) {
    const url = this.uri + '/equipmentDetail?eNo=' + eno;
    const ret: any = await this.httpClient.get(url).toPromise();
    return ret;
  }

  async queryMaintenaceDataByEpNo(eno: string) {
    const url = this.uri + '/queryMaintenaceDataByEpNo?eNo=' + eno;
    const ret: any = await this.httpClient.get(url).toPromise();
    return ret;
  }

  async queryBimDataByEpNo(epNo: string) {
    const url = this.uri + '/queryBIMDataByEpNo?epNo=' + epNo;
    const ret: any = await this.httpClient.get(url).toPromise();
    return ret;
  }

  async queryBimDataByEpPoint(epPoint: string) {
    const url = this.uri + '/queryBIMDataByEpPoint?epPoint=' + epPoint;
    const ret: any = await this.httpClient.get(url).toPromise();
    return ret;
  }

  /** 查询BIM模型数据
   */
  queryBIMDataByLinkage(id): Observable<any> {
    const url = this.uri + '/queryBIMDataByLinkage?id=' + id;
    return this.httpClient.get(url);
  }

  async queryFacilityDataByBarCode(barCode: string) {
    const url = 'plan/api/business/apply/queryEquipmentByBarCode?barCode=' + barCode;
    const ret: any = await this.httpClient.get(url).toPromise();
    return ret;
  }

  async getAllEquipmentsListByCondition(parm: any, pageNum: number, pageSize: number) {
    let url = this.uri + '/queryAllEquipmentByCondition' + '?pageNum=' + pageNum +
      '&pageSize=' + pageSize;
    if (parm.epNo == null || parm.epNo === undefined || parm.epNo === '') {
    } else {
      url = url + '&epNo=' + parm.epNo;
    }
    if (parm.epNos == null || parm.epNos === undefined || parm.epNos.length === 0) {
    } else {
      url = url + '&epNos=' + parm.epNos;
    }
    if (parm.isFault == null || parm.isFault === undefined || parm.isFault === '') {
    } else {
      url = url + '&isFault=' + parm.isFault;
    }
    if (parm.equipmentId == null || parm.equipmentId === undefined || parm.equipmentId === '') {
    } else {
      url = url + '&epNoLike=' + parm.equipmentId;
    }
    if (parm.equipmentName == null || parm.equipmentName === undefined || parm.equipmentName === '') {
    } else {
      url = url + '&epNameLike=' + parm.equipmentName;
    }
    if (parm.storageLocation == null || parm.storageLocation === undefined || parm.storageLocation === '') {
    } else {
      url = url + '&storageLocation=' + parm.storageLocation;
    }
    if (parm.typeId == null || parm.typeId === undefined || parm.typeId === '') {
    } else {
      url = url + '&epType=' + parm.typeId;
    }
    if (parm.markStatus == null || parm.markStatus === undefined || parm.markStatus === '') {
    } else {
      url = url + '&markFlag=' + parm.markStatus;
    }
    // if (parm.expireStatus == null || parm.expireStatus === undefined || parm.expireStatus === '') {
    // } else {
    //   url = url + '&expireStatus=' + parm.expireStatus;
    // }
    //
    if (parm.subtypeId == null || parm.subtypeId === undefined || parm.subtypeId === '') {
    } else {
      url = url + '&epSubtype=' + parm.subtypeId;
    }
    if (parm.equipmentUser == null || parm.equipmentUser === undefined || parm.equipmentUser === '') {
    } else {
      url = url + '&epUserLike=' + parm.equipmentUser;
    }
    if (parm.equipmentLife == null || parm.equipmentLife === undefined || parm.equipmentLife === '') {
    } else {
      url = url + '&epLife=' + parm.equipmentLife;
    }
    if (parm.runningStatus == null || parm.runningStatus === undefined || parm.runningStatus === '') {
    } else {
      url = url + '&epRunningStatus=' + parm.runningStatus;
    }
    if (parm.equipmentLevels == null || parm.equipmentLevels === undefined || parm.equipmentLevels === '') {
    } else {
      url = url + '&epLevel=' + parm.equipmentLevels;
    }
    if (parm.equipmentMaintain == null || parm.equipmentMaintain === undefined || parm.equipmentMaintain === '') {
    } else {
      url = url + '&epMaintainStart=' + this.format(parm.equipmentMaintain[0], 'yyyy-MM-dd');
    }
    if (parm.equipmentMaintain == null || parm.equipmentMaintain === undefined || parm.equipmentMaintain === '') {
    } else {
      url = url + '&epMaintainEnd=' + this.format(parm.equipmentMaintain[1], 'yyyy-MM-dd');
    }
    if (parm.companiesName == null || parm.companiesName === undefined || parm.companiesName === '') {
    } else {
      url = url + '&companiesName=' + parm.companiesName;
    }
    if (parm.departmentsName == null || parm.departmentsName === undefined || parm.departmentsName === '') {
    } else {
      url = url + '&departmentsName=' + encodeURIComponent(parm.departmentsName);
    }
    if (parm.lifeCycles == null || parm.lifeCycles === undefined || parm.lifeCycles === '') {
    } else {
      url = url + '&lifeCycles=' + parm.lifeCycles;
    }
    if (parm.equipmentGuarantee == null || parm.equipmentGuarantee === undefined || parm.equipmentGuarantee === '') {
    } else {
      url = url + '&equipmentGuaranteeStart=' + this.format(parm.equipmentGuarantee[0], 'yyyy-MM-dd');
    }
    if (parm.equipmentGuarantee == null || parm.equipmentGuarantee === undefined || parm.equipmentGuarantee === '') {
    } else {
      url = url + '&equipmentGuaranteeEnd=' + this.format(parm.equipmentGuarantee[1], 'yyyy-MM-dd');
    }
    if (parm.alarmExisting == null || parm.alarmExisting === undefined || parm.alarmExisting === '') {
    } else {
      url = url + '&alarmExisting=' + parm.alarmExisting;
    }
    if (parm.stateExisting == null || parm.stateExisting === undefined || parm.stateExisting === '') {
    } else {
      url = url + '&stateExisting=' + parm.stateExisting;
    }
    // const urlTransform = encodeURIComponent(url);
    const ret: any = await this.httpClient.get(url).toPromise();
    if (ret.code !== 200) {
      console.log(ret.msg);
      return null;
    }
    return ret.data;
  }
  // 当前条件下统计未来月份维保到期设备列表接口
  async getRepairPeriodEquipmentsByCondition(parm: any, pageNum: number, pageSize: number) {
    let url = this.uri + '/getRepairPeriodEquipmentsByCondition' + '?pageNum=' + pageNum +
      '&pageSize=' + pageSize;
    if (parm.month == null || parm.month === undefined || parm.month === '') {
    } else {
      url = url + '&month=' + parm.month;
    }
    if (parm.equipmentLevels == null || parm.equipmentLevels === undefined || parm.equipmentLevels === '') {
    } else {
      url = url + '&epLevel=' + parm.equipmentLevels;
    }
    const ret: any = await this.httpClient.get(url).toPromise();
    if (ret.code !== 200) {
      console.log(ret.msg);
      return null;
    }
    return ret.data;
  }
  getEquipmentsByFilterString(epLike): Observable<any[]> {
    const url = this.uri + '/queryEquipmentsByFilterString?epLike=' + epLike;
    return this.httpClient.get(url).pipe(
      map((res: { data: any[] }) => res.data)
    );
  }
  async getExpiringEquipmentsList(pageNum: number, pageSize: number) {
    const url = this.uri + '/queryExpiringEquipment' + '?pageNum=' + pageNum +
      '&pageSize=' + pageSize;
    const ret: any = await this.httpClient.get(url).toPromise();
    if (ret.code !== 200) {
      console.log(ret.msg);
      return null;
    }
    return ret.data;
  }

  updateEquipment(equipment: any) {
    return this.httpClient.put(this.uri + '/updateEquipmentMarkLocation', equipment).pipe(
      map((res: any) => res.code)
    );
  }
  async getEquipmentByID(epNo: number) {
    const result: any = await this.httpClient.get(this.uri + '/queryEquipmentByID/' + epNo).toPromise();
    if (result == null || result.code !== 200 || result.data == null) {
      return null;
    } else {
      return result.data;
    }
  }
  getEquipmentDashboardData() {
    return this.httpClient.get('plan/api/operation/equipments').toPromise();
  }

  /**
   * 设备数量、完好率、利用率统计查询
   */
  getEquipmentDashboardStaticData() {
    return this.httpClient.get('plan/api/operation/equipments/staticTop').toPromise();
  }

  /**
   * 查询完好率
   */
  getIntactRate() {
    return this.httpClient.get(this.uri + '/queryIntactRate').toPromise();
    // return await this.httpClient.get('plan/api/equipment/queryIntactRate').toPromise();
  }

  async getEquipmentIntactData() {
    const url = 'plan/api/operation/aecEquipments';
    const ret: any = await this.httpClient.get(url).toPromise();
    return ret;
  }
  async getHomeData() {
    return await this.httpClient.get('plan/api/operation/homePage').toPromise();
  }
  async getExpairEquipmentsByMonthes(monthes: number) {
    const result: any = await this.httpClient.get(this.uri + '/queryExpairEquipmentsByMonth/' + monthes).toPromise();
    if (result == null || result.code !== 200 || result.data == null) {
      return null;
    } else {
      return result.data;
    }
  }

  // 添加物资
  async addEquipment(equipment: any) {
    return await this.httpClient.post(this.uri + '/add', equipment).toPromise();
  }

  // 修改物资
  editEquipment(equipment: any) {
    return this.httpClient.put(this.uri + '/edit', equipment).pipe(
      map((res: any) => res)
    );
  }

  // 删除物资
  deleteFacilityBatch(data: any) {
    return this.httpClient.post(this.uri + '/delete', data);
  }

  // 删除BmsState记录
  // deleteFacilityBmsState(srcIndex: any) {
  //   return this.httpClient.post(this.uri + '/deleteBmsState', srcIndex);
  // }
  async deleteFacilityBmsState(sn: string) {
    return await this.httpClient.delete(this.uri + `/deleteBmsStateBySn/${sn}`).toPromise();
  }

  // 获取物资全部维护信息
  getEquipmentMaintainData() {
    return this.httpClient.get(this.uri + '/queryMaintainData');
  }

  // 批量导入物资
  importEquipments(data: any) {
    return this.httpClient.post(this.uri + '/batchAdd', data);
  }

  format(time: any, format: any) {
    const t = new Date(time);
    const tf = (i: number) => {
      return (i < 10 ? '0' : '') + i;
    };
    return format.replace(/yyyy|MM|dd|HH|mm|ss/g, (a: any) => {
      switch (a) {
        case 'yyyy':
          return tf(t.getFullYear());
          break;
        case 'MM':
          return tf(t.getMonth() + 1);
          break;
        case 'mm':
          return tf(t.getMinutes());
          break;
        case 'dd':
          return tf(t.getDate());
          break;
        case 'HH':
          return tf(t.getHours());
          break;
        case 'ss':
          return tf(t.getSeconds());
          break;
      }
    });
  }

  /**
   * 查询当前条件下按级别设备使用和设备维修的数据
   */
  async getLevelUseMaintainData(parm: any) {
    let url = this.uri + '/queryLevelUseMaintainByCondition?1';
    if (parm.equipmentId == null || parm.equipmentId === undefined || parm.equipmentId === '') {
    } else {
      url = url + '&epNoLike=' + parm.equipmentId;
    }
    if (parm.equipmentName == null || parm.equipmentName === undefined || parm.equipmentName === '') {
    } else {
      url = url + '&epNameLike=' + parm.equipmentName;
    }
    if (parm.storageLocation == null || parm.storageLocation === undefined || parm.storageLocation === '') {
    } else {
      url = url + '&storageLocation=' + parm.storageLocation;
    }
    if (parm.typeId == null || parm.typeId === undefined || parm.typeId === '') {
    } else {
      url = url + '&epType=' + parm.typeId;
    }
    if (parm.subtypeId == null || parm.subtypeId === undefined || parm.subtypeId === '') {
    } else {
      url = url + '&epSubtype=' + parm.subtypeId;
    }
    if (parm.equipmentUser == null || parm.equipmentUser === undefined || parm.equipmentUser === '') {
    } else {
      url = url + '&epUserLike=' + parm.equipmentUser;
    }
    if (parm.equipmentLife == null || parm.equipmentLife === undefined || parm.equipmentLife === '') {
    } else {
      url = url + '&epLife=' + parm.equipmentLife;
    }
    if (parm.runningStatus == null || parm.runningStatus === undefined || parm.runningStatus === '') {
    } else {
      url = url + '&epRunningStatus=' + parm.runningStatus;
    }
    if (parm.isFault == null || parm.isFault === undefined || parm.isFault === '') {
    } else {
      url = url + '&isFault=' + parm.isFault;
    }
    if (parm.equipmentMaintain == null || parm.equipmentMaintain === undefined || parm.equipmentMaintain === '') {
    } else {
      url = url + '&epMaintainStart=' + this.format(parm.equipmentMaintain[0], 'yyyy-MM-dd');
    }
    if (parm.equipmentMaintain == null || parm.equipmentMaintain === undefined || parm.equipmentMaintain === '') {
    } else {
      url = url + '&epMaintainEnd=' + this.format(parm.equipmentMaintain[1], 'yyyy-MM-dd');
    }
    if (parm.companiesName == null || parm.companiesName === undefined || parm.companiesName === '') {
    } else {
      url = url + '&companiesName=' + parm.companiesName;
    }
    if (parm.departmentsName == null || parm.departmentsName === undefined || parm.departmentsName === '') {
    } else {
      url = url + '&departmentsName=' + encodeURIComponent(parm.departmentsName);
    }
    if (parm.lifeCycles == null || parm.lifeCycles === undefined || parm.lifeCycles === '') {
    } else {
      url = url + '&lifeCycles=' + parm.lifeCycles;
    }
    if (parm.equipmentGuarantee == null || parm.equipmentGuarantee === undefined || parm.equipmentGuarantee === '') {
    } else {
      url = url + '&equipmentGuaranteeStart=' + this.format(parm.equipmentGuarantee[0], 'yyyy-MM-dd');
    }
    if (parm.equipmentGuarantee == null || parm.equipmentGuarantee === undefined || parm.equipmentGuarantee === '') {
    } else {
      url = url + '&equipmentGuaranteeEnd=' + this.format(parm.equipmentGuarantee[1], 'yyyy-MM-dd');
    }
    if (parm.alarmExisting == null || parm.alarmExisting === undefined || parm.alarmExisting === '') {
    } else {
      url = url + '&alarmExisting=' + parm.alarmExisting;
    }
    if (parm.stateExisting == null || parm.stateExisting === undefined || parm.stateExisting === '') {
    } else {
      url = url + '&stateExisting=' + parm.stateExisting;
    }
    const ret: any = await this.httpClient.get(url).toPromise();
    if (ret.code !== 200) {
      console.log(ret.msg);
      return null;
    }
    return ret;
  }

  /**
   * 查询当前条件下按级别设备使用和设备维修的数据
   */
  async getSparePartsByTypeAndStock(flag: any, typeId: any) {
    const url = 'plan/api/spareParts/querySparePartsByTypeAndStock?1' + '&flag=' + flag + '&typeId=' + typeId;
    const ret: any = await this.httpClient.get(url).toPromise();
    return ret.data;
  }

  /**
   * 查询该月设备的数据
   */
  async getEquipmentsSomeMonth(time: any) {
    const url = 'plan/api/operation/equipmentsSomeMonth?time=' + time;
    const ret: any = await this.httpClient.get(url).toPromise();
    return ret.data;
  }

  /**
   * 查询该月设备的数据
   */
  async getPlansSomeMonth(time: any) {
    const url = 'plan/api/operation/plansSomeMonth?time=' + time;
    const ret: any = await this.httpClient.get(url).toPromise();
    return ret.data;
  }

  /**
   * 设备分类实时运行率
   */
  async getEquipmentOperatingRate() {
    const url = `plan/api/operation/equipmentsRate`;
    const result: any = await this.httpClient.get(url).toPromise();
    // result == null || result.code !== 200 || result.data == null || result.data.length <= 0
    if (result == null || result.code !== 200 || result.data == null) {
      return null;
    }
    return result.data;
  }

  /**
   * 实时设备完好率（饼形图）
   */
  async getEquipmentsRealTime() {
    const url = `plan/api/operation/equipmentsRealTime`;
    const result: any = await this.httpClient.get(url).toPromise();
    // result == null || result.code !== 200 || result.data == null || result.data.length <= 0
    if (result == null || result.code !== 200 || result.data == null) {
      return null;
    }
    return result.data;
  }


  /**
   * 实时设备完好率
   */
  async getEquipmentHistoricalIntegrity() {
    const url = `plan/api/operation/equipmentsHistory`;
    const result: any = await this.httpClient.get(url).toPromise();
    // result == null || result.code !== 200 || result.data == null || result.data.length <= 0
    if (result == null || result.code !== 200 || result.data == null) {
      return null;
    }
    return result.data;
  }

  /**
   * 查询字典信息 asset_level字段
   */
  async getDictionaryDataAssetLevel() {
    const url = `plan/api/dictionary/data?type=asset_level`;
    const result: any = await this.httpClient.get(url).toPromise();
    // result == null || result.code !== 200 || result.data == null || result.data.length <= 0
    if (result == null || result.code !== 200 || result.data == null) {
      return null;
    }
    return result.data;
  }

  /**
   * 备件类型统计
   */
  async selectSpareData() {
    const result: any = await this.httpClient.get('plan/api/operation/equipments/selectSpareData').toPromise();
    if (result == null || result.code !== 200 || result.data == null) {
      return null;
    }
    return result.data;
  }

  /**
   * 运维计划
   */
  async getPlanData() {
    const result: any = await this.httpClient.get('plan/api/operation/equipments/getPlanData').toPromise();
    if (result == null || result.code !== 200 || result.data == null) {
      return null;
    }
    return result.data;
  }

  /**
   * 工具类型统计
   */
  async getToolsData() {
    const result: any = await this.httpClient.get('plan/api/operation/equipments/getToolsData').toPromise();
    if (result == null || result.code !== 200 || result.data == null) {
      return null;
    }
    return result.data;
  }

  /**
   * 根据srcIndex获取BmsState和Alarm
   */
  async getEpAlarmAndState(srcIndex: string) {
    const result: any = await this.httpClient.get(this.uri + `/selectBmsStateAndAlarmBySn/${srcIndex}`).toPromise();
    if (result == null || result.code !== 200 || result.data == null) {
      return null;
    }
    return result;
  }

}
